module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/ledger-account/ledger-account.component.css
// module id = ./src/app/masters/ledger-account/ledger-account.component.css
// module chunks = main